import type { FC } from "react";
import { createContext, useCallback, useContext } from "react";
import type { KeyedMutator } from "swr";

import type { MarketDataMap } from "../hooks";
import { useMarketDataMap } from "../hooks";

export type MarketDataMapState = MarketDataMap;
export type MarketDataMapRefresher = KeyedMutator<MarketDataMap>;

const MarketDataMapContextState = createContext<MarketDataMapState>(new Map());
const MarketDataMapContextRefresher = createContext<MarketDataMapRefresher>(Promise.resolve);

export const MarketDataMapProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { marketDataMap, refresh } = useMarketDataMap();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedRefresh = useCallback(refresh, []);

  return (
    <MarketDataMapContextState.Provider value={marketDataMap}>
      <MarketDataMapContextRefresher.Provider value={memoizedRefresh}>
        {children}
      </MarketDataMapContextRefresher.Provider>
    </MarketDataMapContextState.Provider>
  );
};

export const useMarketDataMapContext = () => useContext(MarketDataMapContextState);
export const useMarketDataMapContextRefresher = () => useContext(MarketDataMapContextRefresher);
